'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');
var Tab = require('./Tab.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var TabsPanel = /*#__PURE__*/function (_React$PureComponent) {
  _rollupPluginBabelHelpers.inherits(TabsPanel, _React$PureComponent);

  var _super = _rollupPluginBabelHelpers.createSuper(TabsPanel);

  function TabsPanel() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, TabsPanel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", {
      activeTab: _this.activeTab(_this.props.children)
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "handleTabSelection", function (selectedTab) {
      _this.setState({
        activeTab: selectedTab
      });
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "renderNavButton", function (tab) {
      if (!tab) return null;
      var classNames = "ds-atom-tab ".concat(tab.props.title === _this.state.activeTab.props.title ? ' selected' : '');
      return /*#__PURE__*/React__default['default'].createElement("button", {
        type: "button",
        className: classNames,
        onClick: function onClick() {
          return _this.handleTabSelection(tab);
        }
      }, tab.props.title);
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(TabsPanel, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        activeTab: this.activeTab(nextProps.children)
      });
    }
  }, {
    key: "activeTab",
    value: function activeTab(children) {
      var childrenArray = React__default['default'].Children.toArray(children);
      return childrenArray.find(function (tab) {
        return tab.props.selected;
      }) || childrenArray[0];
    }
  }, {
    key: "renderNavBar",
    value: function renderNavBar() {
      return /*#__PURE__*/React__default['default'].createElement("nav", {
        className: "ds-atom-tab-menu"
      }, React__default['default'].Children.map(this.props.children, this.renderNavButton));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: this.props.className
      }, this.renderNavBar(), this.state.activeTab);
    }
  }]);

  return TabsPanel;
}(React__default['default'].PureComponent);

_rollupPluginBabelHelpers.defineProperty(TabsPanel, "propTypes", {
  className: PropTypes__default['default'].string,
  children: PropTypes__default['default'].oneOfType([PropTypes__default['default'].shape({
    type: PropTypes__default['default'].oneOf([Tab])
  }), PropTypes__default['default'].arrayOf(PropTypes__default['default'].oneOfType([PropTypes__default['default'].bool, PropTypes__default['default'].shape({
    type: PropTypes__default['default']["function"]
  })]))])
});

_rollupPluginBabelHelpers.defineProperty(TabsPanel, "defaultProps", {
  className: '',
  children: []
});

module.exports = TabsPanel;
